<template>
  <modal :show-close="modalConfig.showClose"
         :wrapper-classes="modalConfig.wrapperClasses"
         @close="$emit('reject')">
    <h2 slot="header" class="modal-title text-3xl text-center sm:text-4xl mt-5 sm:mt-10">
      bonus points
    </h2>
    <h4 slot="subHeader" class="text-xs text-gray-700 text-center font-light px-0 sm:px-10 sm:text-xl">
      configure a bonus points offer that will send out to your recipients, display in their loyalty rewards wallet, and apply on their next transaction
    </h4>
    <bonus-points-form
      slot="body"
      :bonusPointsDraftState="bonusPointsDraftState"
      :campaign="campaign"
    />
    <div slot="action" class="modal-action-click">
      <button class="button done-button" :disabled="isDoneButtonDisabled" @click="clickedDone()" data-cy="bonus-points-done-button">done</button>
    </div>
  </modal>
</template>

<script>
import _ from "lodash";
import BonusPointsForm from "../forms/bonus-points-form.vue";
import Modal from "../../../shared/Modal.vue";

export default {
  name: "bonus-points-modal",

  components: {Modal, BonusPointsForm},

  props: {
    campaign: Object,
    extension: Object
  },

  data() {
    return {
      bonusPointsDraftState: null,
      modalConfig: {
        showClose: true,
        wrapperClasses: ["extensions-modal","bonus-points-modal"]
      },
    }
  },

  async created() {
    this.bonusPointsDraftState = _.cloneDeep(this.extension.payload);
  },

  methods: {
    clickedDone() {
      this.extension.payload = this.bonusPointsDraftState;
      this.$emit("resolve", this.extension);
    }
  },

  computed: {
    isBonusValueEmptyOrLessThan1(){
      return !this.bonusPointsDraftState.bonus_value || this.bonusPointsDraftState.bonus_value < 1;
    },

    isDoneButtonDisabled() {
      return !this.bonusPointsDraftState.item_name ||
             !this.bonusPointsDraftState.expiration_date ||
             this.isBonusValueEmptyOrLessThan1 ||
             !this.bonusPointsDraftState.bonus_type ||
             !this.bonusPointsDraftState.min_purchase_amount;
    },
  }
}
</script>

<style scoped>
.bonus-points,
.bonus-points-modal >>> .attachment-container,
.bonus-points-modal >>> .column {
  align-items: start;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.bonus-points-modal >>> .column {
  margin-bottom: 15px;
}

.bonus-points-modal >>> select,
.bonus-points-modal >>> input {
  font-size: 18px;
}

.bonus-points-modal >>> a {
  font-family: "AileronLight",sans-serif;
  margin-bottom: 5px;
}

.bonus-points-modal >>> svg {
  height: 4rem;
  width: 4rem;
}

.bonus-points-modal >>> img {
  border: 1px solid #128ff9;
  height: 75px;
  margin-top: 8px;
}

.bonus-points-modal >>> span.remove-btn {
  color: #a4a4a4;
  cursor: pointer;
  font-size: .9em;
  margin-left: 15px;
}

.bonus-points-modal >>> .expiration-date {
  border: 1px solid #128ff9;
  border-radius: 8px;
}

.bonus-points-modal >>> .remove-btn:hover{
  color: #f91253;
}

.bonus-points-modal >>> input,
.bonus-points-modal >>> select,
.bonus-points-modal >>> .expiration-date {
  margin-bottom: 0px;
  width: 100%;
}

.bonus-points-modal >>> .error,
.bonus-points-modal >>> .error .tab {
  border-color: #f91253;
}

.bonus-points-modal >>> .sb-loading-icon {
  margin-left: 15px;
}

.bonus-points-modal >>> .tab-container {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom:10px;
  width: 100%;
}

.bonus-points-modal >>> .tab {
  align-items: center;
  border-color: #128fff;
  border-style: solid;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: 'AileronThin',sans-serif;
  line-height: 1;
  padding: 4px 10px;
  min-width: 4rem;
}

.bonus-points-modal >>> .tab span:last-of-type {
  color: #a4a4a4;
  font-size: 12.8px;
  margin-top: 2px;
}

.bonus-points-modal >>> .tab.selected {
  background-color: #128fff;
}

.bonus-points-modal >>> .tab.selected span {
  color: white;
}

.bonus-points-modal >>> .tab:first-child {
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  border-width: 1px;
}

.bonus-points-modal >>> .tab:last-child {
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  border-width: 1px 1px 1px 0;
}

.bonus-points-modal >>> .expiration-date > .label-container {
  color: #000;
}

.sb-loading-icon >>> svg {
  fill: #128ff9;
}

.done-button {
  min-width: 10rem;
  top: 1rem !important;
}
</style>
